import { AppContext, Loader, isAuthorised } from '@nile/components';
import {
  GET_ENTITY_PROPERTIES,
  RMMClient,
  useCachedQuery,
  AccountClient
} from '@nile/graphql';
import {
  GET_TICKETVIEWS,
  GET_TASKVIEWS,
  GET_TASK_LISTVIEW_META
} from '@nile/mangifera/src/Graphql/Mutations/ticketview';
import { GET_PROJECT_VIEWS } from '@nile/projects/src/Graphql';
import {
  GET_PATCH_VIEW_LIST,
  GET_PATCH_DETAIL_VIEW_LIST_META_INFO,
  GET_PATCH_LIST_VIEW_META_INFO_BY_CLASS_ID_AND_VIEW_ID,
  GET_PATCH_LIST_V2
} from '@nile/rmm/src/modules/patch-management/Graphql/patch';
import {
  GET_ALERT_VIEW_LIST,
  GET_ALERT_META_INFO_V4
} from '@nile/rmm/src/modules/alert-management/Graphql/alert';
import {
  GET_ASSET_VIEWS,
  GET_WORK_STATION_META_INFO_V4
} from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import { Delete } from '@styled-icons/material/Delete';
import React, { useContext, useEffect, useState } from 'react';
import RGL from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { SizeMe, withSize } from 'react-sizeme';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import {
  TicketViewWidget,
  TaskViewWidget,
  ProjectViewWidget,
  PatchViewWidget,
  AlertViewWidget,
  MentionViewWidget,
  AssetViewWidget,
  ReportViewWidget
} from './WidgetContainers';
import { useQuery } from '@apollo/client';
import { GET_VIEWS } from '@nile/rmm/src/snmp/SnmpQuery';
import { useFlags } from 'launchdarkly-react-client-sdk';

const ResponsiveHOC = withSize({ monitorHeight: true, monitorWidth: true });
const ReactGridResponsiveLayout = ResponsiveHOC(RGL);

function HomewidgetContainer(props) {
  const { modulePermission } = props;
  const intl = useIntl();
  const [layout, setLayout] = useState(props.layout);

  const appContext = useContext(AppContext);
  const flags = useFlags();
  const isAdvancedHierarchy =
    appContext?.rmmProperties['rmm.policyManagementType'] ===
    'ADVANCED_HIERARCHY';
  const hierarchical =
    appContext?.rmmProperties['rmm.policyManagementType'] === 'HIERARCHICAL';
  // const isNotGrouped = isAdvancedHierarchy || hierarchical;
  const viewAdoptionWithFlag =
    isAdvancedHierarchy || (hierarchical && flags.patchViewAdoption);

  const { user } = appContext;
  const reference = user?.role?.roleFeatureList || [];

  const {
    loading: entityPropertiesLoading,
    data: entityProperties
  } = useCachedQuery(GET_ENTITY_PROPERTIES, { client: AccountClient });

  const { loading: ticketViewsLoading, data: ticketViews } = useCachedQuery(
    GET_TICKETVIEWS,
    {
      skip: !modulePermission.TICKET
    }
  );

  const { loading: taskViewLoading, data: taskViews } = useCachedQuery(
    GET_TASKVIEWS,
    {
      skip: !modulePermission.TASK
    }
  );

  const { loading: projectViewsLoading, data: projectViews } = useCachedQuery(
    GET_PROJECT_VIEWS,
    {
      skip: !modulePermission.PROJECT
    }
  );

  const { loading: patchViewsLoading, data: patchViews } = useQuery(GET_VIEWS, {
    client: RMMClient,
    variables: {
      modules: ['PATCH']
    },
    fetchPolicy: 'no-cache',
    skip: !modulePermission.PATCH
  });

  const { loading: alertViewsLoading, data: alertViews } = useCachedQuery(
    GET_ALERT_VIEW_LIST,
    {
      client: RMMClient,
      skip: !modulePermission.ALERT
    }
  );

  const { loading: assetViewsLoading, data: assetViews } = useCachedQuery(
    GET_ASSET_VIEWS,
    {
      client: RMMClient,
      skip: !modulePermission.ASSET_VIEWS
    }
  );

  const deleteWidget = (widget) => {
    props.deleteWidget(widget);
  };

  const changeLayout = (l) => {
    props.onLayoutChange(l);
  };

  useEffect(() => {
    setLayout(props.layout);
  }, [JSON.stringify(props.layout)]);

  if (
    entityPropertiesLoading ||
    ticketViewsLoading ||
    taskViewLoading ||
    projectViewsLoading ||
    patchViewsLoading ||
    alertViewsLoading ||
    assetViewsLoading
  ) {
    return (
      <WidgetsHolder ref={props.reference} className="full-width full-height">
        <Layout>
          <SizeMe monitorHeight monitorWidth>
            {({ size }) => {
              return (
                <ReactGridResponsiveLayout
                  className="layout"
                  layout={layout}
                  onLayoutChange={(l) => {
                    // changeLayout(l);
                  }}
                  height={size.height}
                  width={size.width}
                  useCSSTransforms
                  cols={12}
                  rowHeight={50}
                  margin={[10, 10]}
                  preventCollision={false}
                  verticalCompact
                  isDraggable={false}
                >
                  {layout.map((item) => {
                    return (
                      <WidgetHolder id={item?.widget?.module} key={item.i}>
                        <Loader />
                      </WidgetHolder>
                    );
                  })}
                </ReactGridResponsiveLayout>
              );
            }}
          </SizeMe>
        </Layout>
      </WidgetsHolder>
    );
  }

  return (
    <WidgetsHolder ref={props.reference} className="full-width full-height">
      <Layout>
        <SizeMe monitorHeight monitorWidth>
          {({ size }) => {
            return (
              <ReactGridResponsiveLayout
                className="layout"
                layout={layout}
                onLayoutChange={(l) => {
                  changeLayout(l);
                }}
                height={size.height}
                width={size.width}
                useCSSTransforms
                measureBeforeMount
                cols={12}
                rowHeight={50}
                margin={[10, 10]}
                preventCollision={false}
                verticalCompact
                draggableHandle=".widget-header"
              >
                {layout.map((item) => {
                  return (
                    <WidgetHolder id={item?.widget?.module} key={item.i}>
                      <Widget
                        item={item}
                        meta={entityProperties?.getEntitiesMeta}
                        user={user}
                        intl={intl}
                        ticketViews={ticketViews?.getTicketViews || []}
                        taskViews={taskViews?.getTaskViews || []}
                        projectViews={projectViews?.getProjectViews || []}
                        patchViews={patchViews?.getViews[0]?.views || []}
                        alertViews={alertViews?.getAlertViews || []}
                        assetViews={assetViews?.getAssetViews || []}
                        deleteWidget={deleteWidget}
                        size={size}
                        reference={reference}
                        isAdvancedHierarchy={viewAdoptionWithFlag}
                      />
                    </WidgetHolder>
                  );
                })}
              </ReactGridResponsiveLayout>
            );
          }}
        </SizeMe>
      </Layout>
    </WidgetsHolder>
  );
}

function Widget(props) {
  const {
    item,
    user,
    intl,
    meta,
    ticketViews,
    taskViews,
    projectViews,
    patchViews,
    alertViews,
    assetViews,
    deleteWidget,
    reference,
    size,
    isAdvancedHierarchy
  } = props;
  const { widget } = item;

  const { loading: taskMetaLoading, data: taskMeta } = useCachedQuery(
    GET_TASK_LISTVIEW_META
  );

  const { loading: patchViewMetaLoading, data: patchViewMeta } = useQuery(
    isAdvancedHierarchy
      ? GET_PATCH_LIST_VIEW_META_INFO_BY_CLASS_ID_AND_VIEW_ID
      : GET_PATCH_DETAIL_VIEW_LIST_META_INFO,
    {
      client: RMMClient,
      skip:
        !isAuthorised(reference, 'patchViews.view') ||
        widget.module !== 'PATCH',
      variables: isAdvancedHierarchy
        ? {
            classId: null,
            viewId: widget?.id
          }
        : null
    }
  );

  const { loading: alertViewMetaLoading, data: alertViewMeta } = useCachedQuery(
    GET_ALERT_META_INFO_V4,
    {
      client: RMMClient,
      skip: !isAuthorised(reference, 'alertView.view')
    }
  );

  const { loading: assetViewMetaLoading, data: assetViewMeta } = useCachedQuery(
    GET_WORK_STATION_META_INFO_V4,
    {
      client: RMMClient,
      skip: !isAuthorised(reference, 'assetViews.view')
    }
  );

  const getWidgetForTicket = (wdg) => {
    switch (wdg?.type) {
      case 'VIEW':
      default:
        return (
          <TicketViewWidget
            ticketViews={ticketViews}
            widget={wdg}
            user={user}
            meta={meta}
            intl={intl}
            deleteWidget={deleteWidget}
          />
        );
    }
  };
  const getWidgetForTask = (wdg) => {
    switch (wdg?.type) {
      case 'VIEW':
      default:
        return (
          <TaskViewWidget
            taskViews={taskViews}
            widget={wdg}
            user={user}
            meta={meta}
            intl={intl}
            deleteWidget={deleteWidget}
            taskViewMeta={taskMeta?.getTaskListViewMetaInfo}
          />
        );
    }
  };
  const getWidgetForProject = (wdg) => {
    switch (wdg?.type) {
      case 'VIEW':
      default:
        return (
          <ProjectViewWidget
            projectViews={projectViews}
            widget={wdg}
            user={user}
            meta={meta}
            intl={intl}
            deleteWidget={deleteWidget}
          />
        );
    }
  };
  const getWidgetForPatch = (wdg) => {
    switch (wdg?.type) {
      case 'VIEW':
      default:
        return (
          <PatchViewWidget
            patchViews={patchViews}
            widget={wdg}
            user={user}
            meta={meta}
            intl={intl}
            deleteWidget={deleteWidget}
            patchViewMeta={
              isAdvancedHierarchy
                ? patchViewMeta?.getPatchListViewMetaInfoByClassIdAndViewId
                : patchViewMeta?.getPatchDetailListViewMetaInfoV2
            }
            isAdvancedHierarchy={isAdvancedHierarchy}
          />
        );
    }
  };
  const getWidgetForAlert = (wdg) => {
    switch (wdg?.type) {
      case 'VIEW':
      default:
        return (
          <AlertViewWidget
            alertViews={alertViews}
            widget={wdg}
            user={user}
            meta={meta}
            intl={intl}
            deleteWidget={deleteWidget}
            alertViewMeta={alertViewMeta?.getAlertViewMetaInfoV4}
          />
        );
    }
  };
  const getWidgetForMentions = (wdg) => {
    switch (wdg?.type) {
      case 'MENTION':
      default:
        return (
          <MentionViewWidget
            projectViews={projectViews}
            widget={wdg}
            user={user}
            meta={meta}
            intl={intl}
            deleteWidget={deleteWidget}
          />
        );
    }
  };

  const getWidgetForReports = (wdg) => {
    return (
      <ReportViewWidget
        widget={wdg}
        user={user}
        meta={meta}
        intl={intl}
        deleteWidget={deleteWidget}
        size={size}
      />
    );
  };

  const getWidgetForAsset = (wdg) => {
    switch (wdg?.type) {
      case 'VIEW':
      default:
        return (
          <AssetViewWidget
            assetViews={assetViews}
            widget={wdg}
            user={user}
            meta={meta}
            intl={intl}
            assetViewMeta={assetViewMeta?.getWorkStationMetaInfoV4}
            deleteWidget={deleteWidget}
          />
        );
    }
  };

  const getWidget = (wdg) => {
    switch (wdg?.module) {
      case 'TICKET':
        return getWidgetForTicket(wdg);
      case 'TASK':
        return getWidgetForTask(wdg);
      case 'PROJECT':
        return getWidgetForProject(wdg);
      case 'PATCH':
        return getWidgetForPatch(wdg);
      case 'ALERT':
        return getWidgetForAlert(wdg);
      case 'ASSET_VIEWS':
        return getWidgetForAsset(wdg);
      default:
        if (wdg?.type === 'MENTION') {
          return getWidgetForMentions(wdg);
        }
        if (wdg.hasOwnProperty('chartId')) {
          return getWidgetForReports(wdg);
        }
        return <div>No data</div>;
    }
  };
  if (
    taskMetaLoading ||
    patchViewMetaLoading ||
    alertViewMetaLoading ||
    assetViewMetaLoading
  )
    return <Loader />;

  return (
    <WidgetWrapper className="visibilityContainer">
      {getWidget(widget)}
    </WidgetWrapper>
  );
}

const WidgetsHolder = styled.div`
  overflow-y: auto;
  scroll-behavior: smooth;
  .react-grid-layout {
    height: auto !important;
    width: 100% !important;
  }
`;

export const WidgetHolder = styled.div.attrs({
  className: 'white-to-grey-bg'
})`
  border: 1px solid var(--sops-home-widget-border);
  box-shadow: 0px 2px 22px rgba(0, 0, 0, 0.0531305);
  border-radius: 8px;
  .empty-data-container {
    margin: 0 !important;
    margin-top: 40px !important;
  }
  .react-resizable-handle {
    visibility: hidden;
  }
  &:hover .react-resizable-handle {
    visibility: visible;
  }
`;

export const WidgetWrapper = styled.div.attrs({
  className: 'full-height full-width'
})``;

const Layout = styled.div`
  background: transparent;
`;

export const Header = styled.div.attrs({ className: 'flex' })`
  height: 70px;
  cursor: ${(props) => (props?.isReadOnly ? 'default' : 'move')};
  padding: 0 8px 0 30px;
`;

export const Title = styled.div.attrs({
  className: 'full-height bold flex actr'
})`
  cursor: ${(props) => (props?.isReadOnly ? 'default' : 'pointer')};
  font-size: 20px;
  line-height: 2;
`;

export const NumberTitle = styled.div.attrs({
  className: 'full-height bold flex actr mb20 ptr jctr'
})`
  font-size: 32px;
`;

export const Content = styled.div.attrs({ className: 'full-width scroll' })`
  height: calc(100% - 70px);
  .table {
    height: 100% !important;
  }
  .unFreezeContent {
    padding-left: 30px;
  }
`;

export const Actions = styled.div.attrs({ className: 'flex actr ptr' })`
  margin-left: auto;
`;

export const NumberCardContainer = styled.div.attrs({
  className: 'widget-header flex full-height full-width ptr'
})`
  cursor: move;
  width: calc(100% - 16px);
  .content {
    margin: auto;
    text-align: center;
    font-weight: 500;
  }
  .icon {
    position: absolute;
    top: 8px;
    left: 8px;
  }
  .visibilityActions {
    left: unset;
    right: 8px;
  }
`;

export const Badge = styled.div.attrs({ className: 'flex actr jctr ptr' })`
  width: 33px;
  height: 33px;
  border-radius: 50%;
  background-color: ${(props) => (props.color ? props.color : '#fce2e0')};
  .emoji {
    margin: auto;
  }
`;

export const DeleteIcon = styled(Delete)`
  height: 24px;
  width: 24px;
  color: black;
`;

export const LoadingPlaceholder = styled.div`
  height: ${(props) => (350 * props.height) / 6}px;
  margin: 10px;
`;

export default HomewidgetContainer;
